<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">
      <el-row>
        <el-col :span="5">
          <div class="cdtitle">下载中心</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">资料下载</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div><a href="https://www.ciepec-online.com:8086/"> 首页>></a></div>
            <div>下载中心>></div>
            <div>{{menuName}}</div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='资料下载'||pageNum==1">
            <div>
              <ul style="overflow: hidden;margin-top: 11px;">
                <li>
                  <a class="xz" href="https://www.ciepec-online.com/u/cms/www/xwy-images/%E5%B1%95%E5%95%86%E6%89%8B%E5%86%8C.pdf" style="    display: block;" target="_blank">
                    <div class="xztit">第二十四届中国国际环保展览会（CIEPEC2026）参展商手册--中文版</div>
                  </a>
                </li>
                <li>
                  <a class="xz" href="https://www.ciepec-online.com/u/cms/www/xwy-images/%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" style="    display: block;" target="_blank">
                    <div class="xztit">线上平台操作简易步骤</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Xzzx',
  data () {
    return {
      menuName: '资料下载',
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
      window.translate.execute()
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}

a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}

.xz {
  display: block;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 10px;
  text-decoration: none;
  color: #333;
  transition: background-color 0.3s;
}
.xz:hover {
  background-color: #e0e0e0;
}
.xztit {
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/xzzx.vue